import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
} from "@mui/material";

import type { FC } from "react";

export const ContentLibraryLoadingModal: FC<{
  open: boolean;
  onClose: () => void;
}> = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="lg">
    <DialogTitle my={2}>Content Library</DialogTitle>
    <DialogContent>
      <LinearProgress />
    </DialogContent>
    <DialogActions>
      <Button data-analytics-id="content-library-loading-cancel" type="button" onClick={onClose}>
        Cancel
      </Button>
    </DialogActions>
  </Dialog>
);
